<div id="listCard" class="card p-2 animate__animated animate__backInDown">
  <app-pctable-action
    [data]="action"
    [header]="fields"
    (parentAction)="parentAction($event)"
  >
  </app-pctable-action>

  <app-pctable
    [data]="data"
    [entityField]="fields"
    (parentAction)="parentAction($event)"
    [sort]="false"
  >
  </app-pctable>

  <app-pcpaging [paging]="paging" (parentAction)="parentAction($event)">
  </app-pcpaging>

  <app-loading-panel *ngIf="listLoading"> </app-loading-panel>
</div>

<app-sale-print-factor
  [modalIsOpen]="receptModalIsOpen"
  [recept]="recept"
  (parentAction)="parentAction($event)"
></app-sale-print-factor>

<app-pcsuccess-modal
  [showModal]="modalSuccessOpen"
  (parentAction)="parentAction($event)"
>
</app-pcsuccess-modal>

<app-pcsetting-modal (parentAction)="parentAction($event)" [fields]="fields">
</app-pcsetting-modal>

<ng-template #searchFilter let-modal class="modal modal-top fade">
  <div class="modal-header border-bottom p-3">
    <h6 id="title-header" class="title-header">
      {{ "SearchFilter" | translate }}
    </h6>
    <button
      type="button"
      class="btn-close-modal btn-icon btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div
        class="col-12 col-xxl-6 col-xl-6 col-lg-12 col-md-12 mb-2 padding-mobile-size"
      >
        <div class="row input-box drug-information-box ms-1 p-2 mb-2">
          <div class="col-12 mb-3">
            <div class="input-box-title-box px-2">
              <span>{{ "DateFilter" | translate : "" }}</span>
            </div>
            <div class="edit-form">
              <label class="form-label m-0">
                {{ "PrescriptionDate" | translate }}
              </label>
              <div
                class="input-group input-daterange"
                id="bs-datepicker-daterange"
              >
                <span class="input-group-text label-span">
                  {{ "From" | translate }}
                </span>
                <input
                  id="PrescDateFrom"
                  type="text"
                  [disabled]="endPoint == 'SaleFactor'"
                  autocomplete="off"
                  placeholder="YYYY/MM/DD"
                  appSelectOnFocus
                  appConvertNumbers
                  (keyup.delete)="filterData.PrescDateFrom = undefined"
                  class="form-control Focusable iner-Focusable"
                  [ngModel]="filterData.PrescDateFrom | dataType : '' : false"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="
                    filterData.PrescDateFrom =
                      calendarService.TypeDate('PrescDateFrom')
                  "
                />
                <ng-template #popoverPrescriptionDateFromDatePicker>
                  <app-data-picker
                    [(childProp)]="filterData.PrescDateFrom"
                    (changeVariableMonth)="changeMonth($event)"
                  ></app-data-picker>
                </ng-template>

                <button
                  class="input-group-text"
                  [disabled]="endPoint == 'SaleFactor'"
                  [ngbPopover]="popoverPrescriptionDateFromDatePicker"
                  [autoClose]="'outside'"
                  #datePicker="ngbPopover"
                >
                  <i class="far fa-calendar-alt"></i>
                </button>

                <span class="input-group-text label-span">
                  {{ "To" | translate }}
                </span>

                <input
                  id="PrescDateTo"
                  type="text"
                  [disabled]="endPoint == 'SaleFactor'"
                  autocomplete="off"
                  appSelectOnFocus
                  appConvertNumbers
                  class="form-control Focusable iner-Focusable"
                  (keyup.delete)="filterData.PrescDateTo = undefined"
                  [ngModel]="filterData.PrescDateTo | dataType : '' : false"
                  [ngModelOptions]="{ standalone: true }"
                  placeholder="YYYY/MM/DD"
                  (ngModelChange)="
                    filterData.PrescDateTo =
                      calendarService.TypeDate('PrescDateTo')
                  "
                />
                <ng-template #popoverPrescriptionDateToDatePicker>
                  <app-data-picker
                    [(childProp)]="filterData.PrescDateTo"
                    (changeVariableMonth)="changeMonth($event)"
                  ></app-data-picker>
                </ng-template>
                <button
                  class="input-group-text"
                  [disabled]="endPoint == 'SaleFactor'"
                  [ngbPopover]="popoverPrescriptionDateToDatePicker"
                  [autoClose]="'outside'"
                  #datePicker="ngbPopover"
                >
                  <i class="far fa-calendar-alt"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="col-12 mb-3">
            <div class="edit-form">
              <label class="form-label m-0">
                {{ "FactorDate" | translate }}
              </label>
              <div
                class="input-group input-daterange"
                id="bs-datepicker-daterange"
              >
                <span class="input-group-text label-span">
                  {{ "From" | translate }}
                </span>
                <input
                  type="text"
                  id="startFactorDate"
                  [disabled]="endPoint == 'SaleFactor'"
                  autocomplete="off"
                  placeholder="YYYY/MM/DD"
                  appSelectOnFocus
                  appConvertNumbers
                  [ngModel]="filterData.FactorDateFrom | dataType : '' : false"
                  class="form-control"
                  (keyup.delete)="filterData.FactorDateFrom = undefined"
                  (ngModelChange)="
                    filterData.FactorDateFrom =
                      calendarService.TypeDate('startFactorDate')
                  "
                />
                <ng-template #popoverFactorDateFromDatePicker>
                  <app-data-picker
                    [(childProp)]="filterData.FactorDateFrom"
                    (changeVariableMonth)="changeMonth($event)"
                  ></app-data-picker>
                </ng-template>
                <button
                  class="input-group-text"
                  [disabled]="endPoint == 'SaleFactor'"
                  [ngbPopover]="popoverFactorDateFromDatePicker"
                  [autoClose]="'outside'"
                  #datePicker="ngbPopover"
                >
                  <i class="far fa-calendar-alt"></i>
                </button>

                <span class="input-group-text label-span">
                  {{ "To" | translate }}
                </span>

                <input
                  type="text"
                  id="endFactorDate"
                  [disabled]="endPoint == 'SaleFactor'"
                  autocomplete="off"
                  placeholder="YYYY/MM/DD"
                  appSelectOnFocus
                  appConvertNumbers
                  [ngModel]="filterData.FactorDateTo | dataType : '' : false"
                  class="form-control"
                  [ngbPopover]="popoverFactorDateToDatePicker"
                  [autoClose]="'outside'"
                  (keyup.delete)="filterData.FactorDateTo = undefined"
                  #datePicker="ngbPopover"
                  (ngModelChange)="
                    filterData.FactorDateTo =
                      calendarService.TypeDate('endFactorDate')
                  "
                />
                <ng-template #popoverFactorDateToDatePicker>
                  <app-data-picker
                    [(childProp)]="filterData.FactorDateTo"
                    (changeVariableMonth)="changeMonth($event)"
                  ></app-data-picker>
                </ng-template>
                <button
                  class="input-group-text"
                  [disabled]="endPoint == 'SaleFactor'"
                  [ngbPopover]="popoverFactorDateToDatePicker"
                  [autoClose]="'outside'"
                  #datePicker="ngbPopover"
                >
                  <i class="far fa-calendar-alt"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-12 col-xxl-6 col-xl-6 col-lg-12 col-md-12 mb-2 padding-mobile-size"
      >
        <div class="row input-box finance-box ms-1 p-2 mb-2">
          <div class="col-12 mb-3">
            <div class="input-box-title-box px-2">
              <span>{{ "PriceFilter" | translate : "" }}</span>
            </div>
            <div class="edit-form">
              <label class="form-label m-0">
                {{ "FactorAmount" | translate }}
              </label>
              <div
                class="input-group input-daterange"
                id="bs-datepicker-daterange"
              >
                <span class="input-group-text label-span">
                  {{ "From" | translate }}
                </span>
                <input
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  placeholder="1,000,000"
                  [(ngModel)]="filterData.TotalPriceFrom"
                  mask="separator.0"
                  thousandSeparator=","
                />
                <span class="input-group-text">
                  {{ "Rial" | translate }}
                </span>

                <span class="input-group-text label-span">
                  {{ "To" | translate }}
                </span>

                <input
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  placeholder="10,000,000"
                  [(ngModel)]="filterData.TotalPriceTo"
                  mask="separator.0"
                  thousandSeparator=","
                />
                <span class="input-group-text">
                  {{ "Rial" | translate }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-12 mb-3">
            <div class="edit-form">
              <label for="startdate" class="form-label m-0">
                {{ "Payable" | translate }}
              </label>
              <div
                class="input-group input-daterange"
                id="bs-datepicker-daterange"
              >
                <span class="input-group-text label-span">
                  {{ "From" | translate }}
                </span>
                <input
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  placeholder="1,000,000"
                  [(ngModel)]="filterData.PaidPriceFrom"
                  mask="separator.0"
                  thousandSeparator=","
                />
                <span class="input-group-text">
                  {{ "Rial" | translate }}
                </span>

                <span class="input-group-text label-span">
                  {{ "To" | translate }}
                </span>

                <input
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  placeholder="10,000,000"
                  [(ngModel)]="filterData.PaidPriceTo"
                  mask="separator.0"
                  thousandSeparator=","
                />
                <span class="input-group-text">
                  {{ "Rial" | translate }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-12 mb-3">
            <div class="edit-form">
              <label for="startdate" class="form-label m-0">
                {{ "InsuranceShare" | translate }}
              </label>
              <div
                class="input-group input-daterange"
                id="bs-datepicker-daterange"
              >
                <span class="input-group-text label-span">
                  {{ "From" | translate }}
                </span>
                <input
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  placeholder="1,000,000"
                  [(ngModel)]="filterData.InsurancePriceFrom"
                  mask="separator.0"
                  thousandSeparator=","
                />
                <span class="input-group-text">
                  {{ "Rial" | translate }}
                </span>

                <span class="input-group-text label-span">
                  {{ "To" | translate }}
                </span>

                <input
                  type="text"
                  autocomplete="off"
                  class="form-control"
                  placeholder="10,000,000"
                  [(ngModel)]="filterData.InsurancePriceTo"
                  mask="separator.0"
                  thousandSeparator=","
                />
                <span class="input-group-text">
                  {{ "Rial" | translate }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 mt-3 mb-2 padding-mobile-size">
        <div class="row input-box stock-box ms-1 p-2 mb-2">
          <div class="col-12 mb-1 mt-3">
            <div class="input-box-title-box px-2">
              <span>{{ "StateFilter" | translate : "" }}</span>
            </div>
            <div class="edit-form">
              <div class="row checkbox-box">
                <div
                  class="col-12 col-lg-2 form-check form-check-primary position-relative"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [(ngModel)]="filterData.TaminPresc"
                    [checked]="filterData.TaminPresc"
                  />
                  <label class="form-check-label" for="TaminTitle">{{
                    "TaminTitle" | translate
                  }}</label>
                </div>
                <div
                  class="col-12 col-lg-2 form-check form-check-primary position-relative"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [(ngModel)]="filterData.SalamatPresc"
                    [checked]="filterData.SalamatPresc"
                  />
                  <label class="form-check-label" for="SalamatInsurance">
                    {{ "SalamatInsurance" | translate }}
                  </label>
                </div>
                <div
                  class="col-12 col-lg-2 form-check form-check-primary position-relative"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [(ngModel)]="filterData.Presc"
                    [checked]="filterData.Presc"
                  />
                  <label class="form-check-label" for="Prescription">{{
                    "Prescription" | translate
                  }}</label>
                </div>
                <div
                  class="col-12 col-lg-2 form-check form-check-primary position-relative"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [(ngModel)]="filterData.FreePresc"
                    [checked]="filterData.FreePresc"
                  />
                  <label class="form-check-label" for="FreePrescription">{{
                    "FreePrescription" | translate
                  }}</label>
                </div>
                <div
                  class="col-12 col-lg-2 form-check form-check-info position-relative"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [(ngModel)]="filterData.OTC"
                    [checked]="filterData.OTC"
                  />
                  <label class="form-check-label" for="otcTitle">{{
                    "otcTitle" | translate
                  }}</label>
                </div>
              </div>

              <div class="row checkbox-box">
                <div
                  class="col-12 col-lg-2 form-check form-check-success position-relative"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [(ngModel)]="filterData.Paid"
                    [checked]="filterData.Paid"
                  />
                  <label class="form-check-label" for="Paid">{{
                    "Paid" | translate
                  }}</label>
                </div>
                <div
                  class="col-12 col-lg-2 form-check form-check-info position-relative"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [(ngModel)]="filterData.OnPayment"
                    [checked]="filterData.OnPayment"
                  />
                  <label class="form-check-label" for="OnPayment">{{
                    "OnPayment" | translate
                  }}</label>
                </div>
                <div
                  class="col-12 col-lg-2 form-check form-check-warning position-relative"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [(ngModel)]="filterData.NoPayment"
                    [checked]="filterData.NoPayment"
                  />
                  <label class="form-check-label" for="NoPayment">{{
                    "NoPayment" | translate
                  }}</label>
                </div>
                <div
                  class="col-12 col-lg-2 form-check form-check-warning position-relative"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [(ngModel)]="filterData.Return"
                    [checked]="filterData.Return"
                  />
                  <label class="form-check-label" for="Return">{{
                    "onReturn" | translate
                  }}</label>
                </div>
                <div class="col-12 col-lg-2 form-check form-check-danger position-relative"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [(ngModel)]="filterData.ReturnComplete"
                    [checked]="filterData.ReturnComplete"
                  />
                  <label class="form-check-label" for="Return">{{
                    "Return" | translate
                  }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer justify-content-center p-2">
    <button type="button" class="btn btn-light" (click)="clearEditItem()">
      <i class="bx bx-x"></i>
      {{ "Clear" | translate }}
    </button>
    <button
      type="submit"
      class="btn btn-primary me-sm-3 me-1 data-submit"
      (click)="getSingleData()"
    >
      <i class="bx bx-check"></i>
      {{ "Submit" | translate }}
    </button>
  </div>
</ng-template>
